import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { materialsStyles } from "../../styles/materials/materialsTableStyles";

export const NoMaterials = () => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell colSpan={9}>
        <Typography noWrap sx={materialsStyles.noMaterials}>
          {t("noConsignedMaterials")}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
